import push from '../utils/push';

const sendCheckoutClick = () => push({ 'event': 'mini-cart-click' });
const sendImpression = () => push({ 'event': 'mini-cart-impression' });

window.VCA = window.VCA || {};

window.VCA.miniCartDatalayer = {
    sendCheckoutClick,
    sendImpression
};

export {
    sendCheckoutClick,
    sendImpression
};
